import styled from 'styled-components';
import Icon from '@ant-design/icons/lib/components/Icon';

export const StyledIcon = styled(Icon)`
  svg {
    width: 100px;
    height: 24px;

    &:hover {
      > path:first-child {
        fill: #226dff;
      }
    }
  }
`;
